<template>
  <div id="fullScreenVideo" v-if="isVisible">
    <el-button class="cstm-icon-btn-medium close-icon" @click="handleCloseButton"></el-button>
    <video controls autoplay controlsList="nodownload" id="fullScreenVideoSrc">
      <template v-if="Array.isArray(videoSrc)">
        <source v-for="(videopreview, key) in videoSrc"
          :key="key"
          :src="$utils.filterMediaPreviewUrl(videopreview.url)"
          :type="videopreview.format"/>
      </template>
      <template v-else>
        <source :src="$utils.filterMediaPreviewUrl(videoSrc)" type="video/mp4">
      </template>
    </video>
  </div>
</template>

<style lang="scss" src="./full-screen-video.scss"></style>
<script src="./full-screen-video.js"></script>
